export default {
  state: {
    bundles: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/BundlesStore.js